/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AddressStructured,
    AddressStructuredFromJSON,
    AddressStructuredFromJSONTyped,
    AddressStructuredToJSON,
} from './';

/**
 * 
 * @export
 * @interface ServiceActualVehicleStateModelsVehicleTransportNextWayPoint
 */
export interface ServiceActualVehicleStateModelsVehicleTransportNextWayPoint {
    /**
     * 
     * @type {number}
     * @memberof ServiceActualVehicleStateModelsVehicleTransportNextWayPoint
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceActualVehicleStateModelsVehicleTransportNextWayPoint
     */
    lon: number;
    /**
     * 
     * @type {string}
     * @memberof ServiceActualVehicleStateModelsVehicleTransportNextWayPoint
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceActualVehicleStateModelsVehicleTransportNextWayPoint
     */
    rta: string;
    /**
     * 
     * @type {string}
     * @memberof ServiceActualVehicleStateModelsVehicleTransportNextWayPoint
     */
    eta: string;
    /**
     * 
     * @type {number}
     * @memberof ServiceActualVehicleStateModelsVehicleTransportNextWayPoint
     */
    estimatedDistance?: number;
    /**
     * 
     * @type {number}
     * @memberof ServiceActualVehicleStateModelsVehicleTransportNextWayPoint
     */
    remainingDistancePercentage?: number;
    /**
     * 
     * @type {Array<AddressStructured>}
     * @memberof ServiceActualVehicleStateModelsVehicleTransportNextWayPoint
     */
    addressStructured?: Array<AddressStructured>;
}

export function ServiceActualVehicleStateModelsVehicleTransportNextWayPointFromJSON(json: any): ServiceActualVehicleStateModelsVehicleTransportNextWayPoint {
    return ServiceActualVehicleStateModelsVehicleTransportNextWayPointFromJSONTyped(json, false);
}

export function ServiceActualVehicleStateModelsVehicleTransportNextWayPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceActualVehicleStateModelsVehicleTransportNextWayPoint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lat': json['lat'],
        'lon': json['lon'],
        'name': json['name'],
        'rta': json['rta'],
        'eta': json['eta'],
        'estimatedDistance': !exists(json, 'estimatedDistance') ? undefined : json['estimatedDistance'],
        'remainingDistancePercentage': !exists(json, 'remainingDistancePercentage') ? undefined : json['remainingDistancePercentage'],
        'addressStructured': !exists(json, 'addressStructured') ? undefined : ((json['addressStructured'] as Array<any>).map(AddressStructuredFromJSON)),
    };
}

export function ServiceActualVehicleStateModelsVehicleTransportNextWayPointToJSON(value?: ServiceActualVehicleStateModelsVehicleTransportNextWayPoint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lat': value.lat,
        'lon': value.lon,
        'name': value.name,
        'rta': value.rta,
        'eta': value.eta,
        'estimatedDistance': value.estimatedDistance,
        'remainingDistancePercentage': value.remainingDistancePercentage,
        'addressStructured': value.addressStructured === undefined ? undefined : ((value.addressStructured as Array<any>).map(AddressStructuredToJSON)),
    };
}


